export { SortableModule } from './sortable.module';
export { SortableComponent } from './sortable.component';
export { DraggableItemService } from './draggable-item.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ngx-bootstrap/sortable/index.js
// module id = ../../../../ngx-bootstrap/sortable/index.js
// module chunks = 3